<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	import { localReq, postReq } from '../../../../services/http';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Design system components
	import { Button, Input, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	let min = 60,
		max = 200,
		loading = false;

	let localIp = get_local_ip(id);

	let value = settings[device.category + 's'][0].btn_debounce;
	let cache = value;

	const setBtnDebounce = async () => {
		if (cache !== value) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(
					device,
					`${localIp}/settings/${device.category}/${device.channel}/`,
					'post',
					{
						btn_debounce: value,
					},
				);
			} else {
				res = await postReq(`/device/${device.category}/settings/button_debounce`, {
					id: device.id,
					time: value,
					channel: device.channel,
				});
			}
			if (res.isok) {
				toast.open({
					type: 'success',
					title:
						$format('button_debounce_change_value_scc_toast', {
							values: { value },
						}) || `Button debounce was changed to ${value}ms.`,
				});
				settings[device.category + 's'][0].btn_debounce = value;
				devices_settings.update_devices_settings(id, settings);
				cache = value;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Input
	class="mb-s"
	size="m"
	bind:value
	type={'number'}
	{min}
	{max}
	info={$format('button_debounce_description', {
		values: { min, max },
		default:
			'Adjust the input sensitivity. In case of multiple status changes. Higher numbers lead to lower sensitivity. Button debounce, ({min} - {max}) milliseconds.',
	})}
	on:enter={setBtnDebounce}
	id="input-6m1o0ve"
	aria-label={$format('button_debounce_description', {
		values: { min, max },
		default:
			'Adjust the input sensitivity. In case of multiple status changes. Higher numbers lead to lower sensitivity. Button debounce, ({min} - {max}) milliseconds.',
	})}
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={setBtnDebounce}
	>{$format('button_save')}</Button
>
